export default __webpack_public_path__ + "static/media/shoothillFooterLogo.05c0b112.svg";